import { type Enum } from '@webapp/utils'
import { CostAdjustmentTypes } from './CostAdjustmentType'

export const TaxTypes = {
  AMOUNT: CostAdjustmentTypes.amount,
  PERCENT: CostAdjustmentTypes.percent,
} as const

export type TaxType = Enum<typeof TaxTypes>
